export type ColorModeContrastPreference = "system" | "less" | "more";

export type ColorVisionDeficiencyPreference =
  | "none"
  | "red-green"
  | "tritanopia";

export type UserAccessibilityPreferencesPayload = {
  color_mode_contrast?: ColorModeContrastPreference;
  color_vision_deficiency?: ColorVisionDeficiencyPreference;
};

export const COLOR_MODE_CONTRAST_OPTIONS: readonly ColorModeContrastPreference[] =
  ["system", "less", "more"];

export const COLOR_VISION_DEFICIENCY_OPTIONS: readonly ColorVisionDeficiencyPreference[] =
  ["none", "red-green", "tritanopia"];

/**
 * Fallback values for every accessibility axis. Mirrors the backend's
 * `UserAccessibilityPreferences.default_preferences()`. Used to seed optimistic
 * updates so setting one axis never drops the others.
 */
export const DEFAULT_ACCESSIBILITY_PREFERENCES = {
  color_mode_contrast: "system",
  color_vision_deficiency: "none",
} as const satisfies Required<UserAccessibilityPreferencesPayload>;
